export default __webpack_public_path__ + "static/media/3.9bf93dd4.svg";